import { StoreAction, XmAction } from 'store/actions';
import { GtpSessionCollection, RelatedStatementTransactionCollection, SsmEstimated, SsmHistorical, SsmStatementListV2, Statement, StatementV2Pdf } from './models';
import { PaymentState } from 'my-account/constants';
import { StatementList } from './models/statement-list';
import { SsmStatementList } from './models/ssm-statement-list';
import { StatementPdf } from './models/statement-pdf';

export function statementReducer(state: Statement[] = [], action: XmAction<Statement>): Statement[] {
    switch (action.type) {
        case StoreAction.GET_ESTIMATED:
        case StoreAction.GET_STATEMENT:
            return [ ...state, action.payload ];
        case StoreAction.CLEAR_STATEMENT:
            if (action.filters) {
                switch (action.filters.paymentState) {
                    case PaymentState.ESTIMATED:
                        return state.filter((statement: Statement) => !statement.isEstimated);
                    case PaymentState.PENDING:
                        return state.filter((statement: Statement) => !statement.isNextPayment);
                    case PaymentState.PAST_DUE:
                        return state.filter((statement: Statement) => !statement.isPastDue);
                }
            }

            // if no filter
            return undefined;

        default:
            return state;
    }
}

export function relatedStatementTransactionCollectionReducer(state: RelatedStatementTransactionCollection[] = [], action: XmAction<RelatedStatementTransactionCollection>): RelatedStatementTransactionCollection[] {
    switch (action.type) {
        case StoreAction.GET_RELATED_STATEMENT_TRANSACTIONS:
            return [ ...state, action.payload ];
        case StoreAction.CLEAR_RELATED_STATEMENT_TRANSACTIONS:
            return state.filter((relatedStatementTransactionCollection: RelatedStatementTransactionCollection) => relatedStatementTransactionCollection.statementId !== action.filters.statementId);
        case StoreAction.CLEAR_ALL_RELATED_STATEMENT_TRANSACTIONS:
            return undefined;
        default:
            return state;
    }
}

export function statementListReducer(state: StatementList, action: XmAction<StatementList>): StatementList {
    switch (action.type) {
        case StoreAction.GET_STATEMENT_LIST:
            return action.payload;
        case StoreAction.CLEAR_STATEMENT_LIST:
            return undefined;
        default:
            return state;
    }
}

export function ssmStatementListReducer(state: SsmStatementList, action: XmAction<SsmStatementList>): SsmStatementList {
    switch (action.type) {
        case StoreAction.GET_SSM_STATEMENT_LIST:
            return action.payload;
        case StoreAction.CLEAR_SSM_STATEMENT_LIST:
            return undefined;
        default:
            return state;
    }
}

export function ssmStatementListV2Reducer(state: SsmStatementListV2, action: XmAction<SsmStatementListV2>): SsmStatementListV2 {
    switch (action.type) {
        case StoreAction.GET_SSM_STATEMENT_LIST_V2:
            return action.payload;
        case StoreAction.CLEAR_SSM_STATEMENT_LIST_V2:
            return undefined;
        default:
            return state;
    }
}

export function gtpSessionCollectionReducer(state: GtpSessionCollection[] = [], action: XmAction<GtpSessionCollection>): GtpSessionCollection[] {
    switch (action.type) {
        case StoreAction.GET_GTP_SESSION_COLLECTION:
            return [ ...state, action.payload ];
        case StoreAction.CLEAR_RELATED_GTP_SESSION_COLLECTION:
            return state.filter((gtpSessionCollection: GtpSessionCollection) => gtpSessionCollection.statementId !== action.filters.statementId);
        case StoreAction.CLEAR_ALL_GTP_SESSION_COLLECTION:
            return undefined;
        default:
            return state;
    }
}

export function ssmEstimatedReducer(state: SsmEstimated, action: XmAction<SsmEstimated>): SsmEstimated {
    switch (action.type) {
        case StoreAction.GET_SSM_ESTIMATED:
            return action.payload;
        default:
            return state;
    }
}

export function ssmHistoricalReducer(state: SsmHistorical, action: XmAction<SsmHistorical>): SsmHistorical {
    switch (action.type) {
        case StoreAction.GET_SSM_HISTORICAL_STATEMENT:
            return action.payload;
        default:
            return state;
    }
}

export function ssmHistoricalV2Reducer(state: SsmHistorical, action: XmAction<SsmHistorical>): SsmHistorical {
    switch (action.type) {
        case StoreAction.GET_SSM_HISTORICAL_STATEMENT_V2:
            return action.payload;
        default:
            return state;
    }
}

export function statementPdfReducer(state: StatementPdf, action: XmAction<StatementPdf>): StatementPdf {
    switch (action.type) {
        case StoreAction.GET_STATEMENT_PDF:
            return action.payload;
        default:
            return state;
    }
}

export function statementPdfV2Reducer(state: StatementV2Pdf, action: XmAction<StatementV2Pdf>): StatementV2Pdf {
    switch (action.type) {
        case StoreAction.GET_STATEMENT_V2_PDF:
            return action.payload;
        default:
            return state;
    }
}
